export default "__VITE_ASSET__BUW0LAZ6__"